webpackJsonp([171728492083027],{

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Models = __webpack_require__(18);
	
	var _Models2 = _interopRequireDefault(_Models);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Models2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'toJSON'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'toJSON()'
	      ),
	      ' method returns a copy of the model\'s attributes.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import _ from \'lodash\';\n      ...\n      toJSON: function(options) {\n        return _.clone(this.attributes);\n      },\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s say you have a model that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend({\n        urlRoot: \'http://localhost:1337/tweets\'\n      })\n\n      const tweet = new Tweet({\n        id: 1,\n        text: \'Some tweet\'\n      });\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then invoking ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.toJSON()'
	      ),
	      ' would return this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        id: 1,\n        text: \'Some tweet\'\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-models-properties-to-json-js-950edcebd70263c3b264.js